<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <div class="fileupload p-0">
          <fileUploadV2
            ref="uploadV2"
            v-model="fileItems"
            class="btn btn-primary"
            :class="buttonClass"
            :upload-url="apiUpload"
            :headers="customHeader"
            :data="customData"
            :accept="acceptMimetypes.join(',')"
            :accept-extensions="acceptExtensions.join(',')"
            :image-extensions="imageExtensions"
            :audio-extensions="audioExtensions"
            :video-extensions="videoExtensions"
            :document-extensions="documentExtensions"
            :image-mimetypes="imageMimetypes"
            :audio-mimetypes="audioMimetypes"
            :video-mimetypes="videoMimetypes"
            :document-mimetypes="documentMimetypes"
            :multiple="true"
            :maximum="10"
            :size="maxUploadSize"
            :timeout="uploadTimeout"
            :chunk-options="chunkOptions"
            :input-id="inputId"
            @input-file="inputFileV2"
            @input-filter="inputFilterV2"
            @upload-progress="onUploadProgress"
            @upload-success="onUploadSuccess"
            @upload-error="onUploadError"
          >

            <feather-icon icon="PlusCircleIcon" /> {{ textUploadButton }}

          </fileUploadV2>
          <b-button
            v-show="fileItems.length"
            v-if="!isUploadAll && !autoUpload"
            variant="outline-primary"
            class="ml-1"
            @click="uploadAll"
          >
            <feather-icon icon="PlayIcon" /> Tải tất cả
          </b-button>
          <b-button
            v-show="fileItems.length"
            v-if="isUploadAll && !autoUpload"
            variant="outline-primary"
            class="ml-1"
            @click="pauseAll"
          >
            <feather-icon icon="PauseIcon" /> Dừng tất cả
          </b-button>
        </div>
      </div>

      <div class="col-md-4 d-flex justify-content-end">
        <slot name="fileupload-right">
          <b-form-checkbox
            v-if="showSyncDalet"
            v-model="sync_dalet"
            class="checkboxLabel"
            value="1"
          > Gửi tới dalet
          </b-form-checkbox>
        </slot>
      </div>
    </div>

    <div
      v-if="preUploading"
      class="py-1 text-primary"
    >
      {{ preMessage }}
    </div>
    <slot
      name="file-list"
      :file-data-list="fileItems"
    >
      <div class="showData files-list">
        <b-row
          v-for="(item, index) in fileItems"
          v-show="!item.deleted"
          :key="index"
          class="mt-1"
        >
          <b-col md="5">
            <p
              class="text-break"
              @click="onClickFile(item)"
            >
              {{ item.filename_original }}
            </p>
            <span
              v-if="item.error"
              class="text-danger text-wrap text-break"
            > {{ item.error }} </span>
            <span
              v-if="item.success"
              class="text-success text-wrap text-break"
            > {{ item.success }} </span>
          </b-col>
          <b-col md="4">
            <p>{{ formatFileSize(item.progress * item.size / 100) }}/{{ formatFileSize(item.size) }}</p>
            <b-progress
              max="100"
              show-value
              variant="success"
              class="progress-bar-success"
            >
              <b-progress-bar
                :value="item.progress"
                :label="`${item.progress}%`"
                variant="success"
              />
            </b-progress>
          </b-col>
          <b-col
            class="text-center"
            md="3"
          >
            <b-button
              v-if="!item.active && !item.uploaded && item.isValid && item.validOnServer"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="btn-icon rounded-circle"
              :disabled="!item.isValid"
              @click.prevent="startUpload(item)"
            >
              <feather-icon icon="PlayIcon" />
            </b-button>
            <b-button
              v-if="item.active && !item.uploaded && item.isValid && item.validOnServer"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="btn-icon rounded-circle"
              @click.prevent="cancelUpload(item)"
            >
              <feather-icon icon="PauseIcon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-danger"
              class="btn-icon rounded-circle ml-1"
              @click.prevent="confirmDeleteFileContent(item)"
            >
              <feather-icon icon="XIcon" />
            </b-button>
          </b-col>
        </b-row>
      </div>
    </slot>
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api';
import {
  BRow, BCol, BProgress, BProgressBar, BFormCheckbox, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import FileUploadV2 from '@/@core/components/fileupload/FileUpload.vue'
import { getToken } from '@/auth/utils'
import store from '@/store';
import { apiUpload, apiUploadChunk } from '@/libs/initTinymce';
import useFiles from '../useFiles';

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BProgress,
    BProgressBar,
    FileUploadV2,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    autoUpload: {
      type: Boolean,
      default: false,
    },
    removeFileAfterSuccess: {
      type: Boolean,
      default: false,
    },
    closeModalAfterAllSuccess: {
      type: Boolean,
      default: true,
    },
    confirmDelete: {
      type: Boolean,
      default: true,
    },
    showSyncDalet: {
      type: Boolean,
      default: true,
    },
    syncDalet: {
      type: Boolean,
      default: true,
    },
    onlySyncAudio: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: String,
      default: '',
    },
    inputId: {
      type: String,
      default: 'input-upload-file-v2',
    },
    textUploadButton: {
      type: String,
      default: 'Thêm files...',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      apiUpload,
      apiUploadChunk,
      sync_dalet: this.syncDalet ? 1 : 0,
      isUploadAll: false,
      preUploading: false,
      preUploadingMessage: 'Chuẩn bị tải file...',
      preCheckValidMessage: 'Đang kiểm tra thông tin file...',
      preMessage: 'Đang kiểm tra thông tin file...',
    }
  },
  computed: {
    fileItems: {
      get() {
        return this.value || [];
      },
      set(val) {
        // console.log('val', val);
      },
    },
  },
  setup(props, context) {
    const selectedCategory = computed(() => store.state.files.selected_category)
    const accessToken = getToken();
    const customHeader = ref({
      Authorization: `Bearer ${accessToken}`,
    })
    const customData = ref({
      upload_status: 1,
      category_id: selectedCategory.value ? selectedCategory.value.id : '',
    })

    const {
      fileSettingDatas,
      acceptMimetypes,
      acceptExtensions,
      imageExtensions,
      audioExtensions,
      videoExtensions,
      documentExtensions,
      maxUploadSize,
      uploadTimeout,
      requestQueue,
      updateFileLog,
      chunkOptions,
      allowSyncDalet,
      createChunk,
    } = useFiles();

    let imageMimetypes = fileSettingDatas.image_mimetypes;
    const audioMimetypes = fileSettingDatas.audio_mimetypes;
    let videoMimetypes = fileSettingDatas.video_mimetypes;
    let documentMimetypes = fileSettingDatas.document_mimetypes;

    console.log('props.onlySyncAudio', props.onlySyncAudio);
    console.log('1.acceptMimetypes', acceptMimetypes);
    if (props.onlySyncAudio) {
      imageMimetypes = [];
      videoMimetypes = [];
      documentMimetypes = [];
      acceptMimetypes.value = [];
      [...fileSettingDatas.value.audio_mimetypes].forEach(val => {
        acceptMimetypes.value.push(val);
      })
    }
    console.log('acceptMimetypes', acceptMimetypes);
    console.log('audioMimetypes', audioMimetypes);
    return {
      customHeader,
      customData,
      selectedCategory,
      acceptMimetypes,
      acceptExtensions,
      imageExtensions,
      audioExtensions,
      videoExtensions,
      documentExtensions,
      imageMimetypes,
      audioMimetypes,
      videoMimetypes,
      documentMimetypes,
      maxUploadSize,
      uploadTimeout,
      requestQueue,
      chunkOptions,
      updateFileLog,
      allowSyncDalet,
      createChunk,

    }
  },
  mounted() {
    store.dispatch('files/setState', { number_uploaded_files: 0 })
  },
  methods: {
    showAlertPopup(msg) {
      if (msg) {
        this.$swal({
          title: 'Cảnh báo',
          html: msg,
          allowOutsideClick: true,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        })
      }
    },
    deleteUploadFile(file) {
      this.$refs.uploadV2.remove(file);
    },
    confirmDeleteFileContent(file) {
      if (this.confirmDelete) {
        this.$swal({
          title: 'Bạn chắc muốn xóa?',
          text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
          icon: 'error',
          showCancelButton: true,
          confirmButtonText: 'Có',
          cancelButtonText: 'Không',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.deleteUploadFile(file);
          }
        })
      } else {
        this.deleteUploadFile(file);
      }
      this.$emit('input', this.fileItems);
    },
    validMimetypeOnServer(fileObject, callback) {
      if (fileObject.validOnServer) {
        if (typeof callback === 'function') {
          callback(fileObject)
        }
      } else {
        const formData = new FormData();
        formData.append('file', this.createChunk(fileObject.file));
        formData.append('file_size', fileObject.size);
        formData.append('filename_original', fileObject.filename_original);
        fileObject.validOnServer = false;
        this.preUploading = true;
        this.preMessage = this.preCheckValidMessage;
        store.dispatch('files/checkMimetype', formData)
          .then((res) => {
            // console.log('validMimetypeOnServer res: ', res.status, res.message);
            this.preUploading = false;
            fileObject.validOnServer = true;
            if (res.status === 200) {
              if (res.data.code === 200) {
                fileObject.mimetype = res.data.data.mime_type;
                fileObject.isValid = true;

                fileObject.isAudio = this.$refs.uploadV2.checkIsAudio(fileObject.extension, fileObject.mimetype);
                fileObject.isVideo = this.$refs.uploadV2.checkIsVideo(fileObject.extension, fileObject.mimetype);

                // check if has duration and over
                if (res.data.data.over_duration !== undefined && fileObject.isAudio) {
                  fileObject.sync_dalet = res.data.data.over_duration ? 0 : 1;
                  fileObject.over_duration = res.data.data.over_duration;
                }

                if (typeof callback === 'function') {
                  callback(fileObject)
                }
              } else {
                // const msg = `Chỉ hỗ trợ định dạng: ${this.acceptExtensions.join(', ')}`;
                fileObject.error = res.data.message;
                fileObject.isValid = false;
                this.showAlertPopup(fileObject.error);
                if (!fileObject.duplicated) {
                  this.deleteUploadFile(fileObject);
                }
              }
            }
            if (res.status === 400) {
              this.deleteUploadFile(fileObject);
            }
          })
          .catch((err) => {
            console.log('err chekmime', err);
            fileObject.isValid = false;
            fileObject.error = 'Đã có lỗi xảy ra. Vui lòng thử lại sau';
            // this.showAlertPopup(fileObject.error);

            // auto retry
            setTimeout(() => {
              this.validMimetypeOnServer(fileObject, callback)
            }, 1000);
          });
      }
    },
    inputFilterV2(fileObject) {
      this.showAlertPopup(fileObject.error);
      if (fileObject.error && !fileObject.duplicated) {
        this.deleteUploadFile(fileObject);
      }
      if (this.autoUpload && fileObject.error === '') {
        this.startUpload(fileObject)
      }
    },
    inputFileV2(fileObject) {
      // console.log('inputFileV2--> input file --> fileObject ', fileObject);
    },
    onClickFile(item) {
      this.$emit('click-file', item);
    },
    onUploadProgress(fileObject) {
      // console.log('inputProgressV2 fileObject.progress --> ', fileObject.progress);
    },
    onUploadSuccess(fileObject) {
      // console.log('onUploadSuccess --> ', fileObject);
      this.updateFileLog({
        file_id: fileObject.id,
        file_name: fileObject.filename,
        file_original: fileObject.filename_original,
        source: this.allowSyncDalet(fileObject) ? 3 : 1,
        action: 1,
        code: 1,
        message: 'Upload thành công',
        progress: '100',
      });
      if (this.fileItems.length) {
        let isUploadedAll = true;
        this.fileItems.forEach(o => {
          if (!o.uploaded) {
            isUploadedAll = false
          }
        });
        if (isUploadedAll && this.closeModalAfterAllSuccess) {
          this.$emit('hide-modal-upload')
        }
        if (isUploadedAll) {
          this.$emit('on-uploaded-all');
        }
        this.$emit('input', this.fileItems);
      }
      if (this.removeFileAfterSuccess) {
        this.deleteUploadFile(fileObject);
      }
    },
    onUploadError(fileObject) {
      // console.log('onUploadError --> ', fileObject);
      this.updateFileLog({
        file_id: fileObject.id,
        file_name: fileObject.filename,
        file_original: fileObject.filename_original,
        source: this.allowSyncDalet(fileObject) ? 3 : 1,
        action: 1,
        code: 2,
        message: `Upload lỗi: ${fileObject.error}`,
        progress: fileObject.progress,
      })
    },
    cancelUpload(item) {
      this.$refs.uploadV2.cancel(item)
      // check if cancal all then show upload all btn
      let isCancelAll = true;
      this.fileItems.forEach(o => {
        if (o.active) {
          isCancelAll = false
        }
      });
      if (isCancelAll) {
        this.isUploadAll = false
      }
    },
    startUpload(item) {
      if (item.active || item.uploaded || item.deleted || !item.isValid) {
        return;
      }

      // console.log('if file not start and not uploaded then retry', item);
      if (!item.active && !item.uploaded) {
        console.log('retry file not start and not uploaded', item);
        setTimeout(() => {
          this.startUpload(item);
        }, 5000);
      }

      this.validMimetypeOnServer(item, () => {
        const metas = {
          name: item.name,
          filename: item.filename,
          filename_original: item.filename_original,
          path: item.file_path,
          mimetype: item.mimetype,
          extension: item.extension,
          size: item.size,
          category_id: this.selectedCategory ? this.selectedCategory.id : 0,
          sync_dalet: this.allowSyncDalet(item) ? Number(this.sync_dalet) : 0,
        }
        // console.log('after valid mimetype item: ', item, this.allowSyncDalet(item));
        this.isUploadAll = true;
        // return console.log('startUpload item metas', metas);
        const existFile = this.findFile(item);
        // console.log('existFile', existFile);
        if (!existFile.id || existFile.id === undefined) {
          this.preUploading = true;
          this.preMessage = this.preUploadingMessage;
          store.dispatch('files/uploadChunkFile', metas)
            .then((res) => {
              this.preUploading = false;
              if (res.status === 200) {
                item.disabled = false;
                if (res.data.code === 200) {
                  const { fileData } = res.data.data;

                  // set new filename
                  metas.filename = fileData.file;
                  metas.path = fileData.file_path;

                  item.id = fileData.id;
                  item.filename = fileData.file;
                  item.file_path = fileData.file_path;
                  item.file_local = fileData.file_local;
                  item.file_path = fileData.file_local;
                  item.category_id = fileData.category_id;

                  store.dispatch('files/setState', { number_uploaded_files: 1 })
                  console.log('upload metas', metas);
                  this.$refs.uploadV2.upload(item, metas)
                } else {
                  item.error = res.data.message
                  console.log('item.error', item.error);
                }
              } else {
                item.error = res.data.message
                console.log('item.error', item.error);
              }
            });
        } else {
          metas.filename = existFile.filename;
          metas.path = existFile.file_path;
          this.$refs.uploadV2.upload(existFile, metas)
        }
      })
    },
    uploadAll() {
      if (this.fileItems.length) {
        this.fileItems.forEach(item => {
          if (!item.active && !item.deleted && !item.uploaded && item.isValid) {
            this.startUpload(item);
          }
        });
      }
      this.isUploadAll = true
    },
    pauseAll() {
      if (this.fileItems.length) {
        this.fileItems.forEach(item => {
          if (item.active && !item.uploaded) {
            this.cancelUpload(item);
          }
        });
      }
      this.isUploadAll = false
    },
    findFile(item) {
      return this.fileItems.find((o) => o.key === item.key)
    },
    findIndexFile(item) {
      return this.fileItems.findIndex((o) => o.key === item.key)
    },
    formatFileSize(bytes, decimals) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals || 2;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
  },
}
</script>
